<template>
  <div id="top-bar">
    <!-- ========== Topbar Start ========== -->
    <div class="navbar-custom">
      <div class="topbar container-fluid">
        <div class="d-flex align-items-center gap-1">
          <!-- <mobile-menu v-if="MobileViewFlag" /> -->
          <mobile-menu />

          <!-- Horizontal Menu Toggle Button -->
          <!-- <button
            class="navbar-toggle"
            data-bs-toggle="collapse"
            data-bs-target="#topnav-menu-content"
          >
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button> -->
          <!-- Role Name - {{ RoleName }};  Role Id - {{ RoleId }} -->
        </div>

        <ul class="topbar-menu d-flex align-items-center mt-3">
          <span class="account-user-avatar">
            <!-- {{ MembershipId }} -->
            {{ DisplayName }}
            <img
              :src="ProfilePic"
              alt="jci-member"
              width="32"
              height="32"
              class="rounded-circle ml-2"
            />
          </span>

          <v-btn plain @click="LogoutUser">
            <!-- <i class="ri-logout-box-line"></i> -->
            <v-icon color="#D50000" style="font-size: 20px"
              >mdi-logout-variant</v-icon
            >
            <span class="logout-txt">Logout</span>
          </v-btn>
        </ul>
      </div>
    </div>
  </div>

  <!-- ========== Topbar End ========== -->
</template>

<script>
import Common from "@/Common.vue";
import companyConfig from "@/company_config.json";
import MobileMenu from "@/components/MobileMenu.vue";

export default {
  mixins: [Common],
  components: {
    MobileMenu,
  },
  data() {
    return {
      ProfilePic: "",
      RoleName: "",
      DisplayName: "",
      RoleId: 0,
      MembershipId: 0,
      // MobileViewFlag: false,
    };
  },
  // created() {
  //   window.addEventListener("resize", this.handleResize);
  //   this.handleResize();
  // },
  methods: {
    // handleResize() {
    //   console.log("handleResize called");
    //   var window_width = window.innerWidth;
    //   console.log({ window_width });
    //   this.MobileViewFlag = window_width > 767 ? false : true;
    // },
    refreshPageData() {
      console.log("refreshPageData called");
      var server_url = companyConfig.apiURL;

      var user = this.$session.get("User");
      user = user == (null || undefined) ? {} : user;

      console.log({ server_url }, { user });

      this.ProfilePic = user.MemberPhoto;
      this.RoleName = user.RoleName;
      this.DisplayName = user.DisplayName;
      this.RoleId = user.RoleId;
      this.MembershipId = user.MembershipId;
    },
  },

  beforeMount() {
    console.log("beforeMount called");
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
.top-bar {
  #navbar-custom {
    margin-left: 0;
    padding-left: 0;
  }
}
</style>
